export const normalizeVariantId = (id) => String(id);

export const toggleVariantId = (currentIds, variantId) => {
  const id = normalizeVariantId(variantId);
  const normalized = (currentIds || []).map(normalizeVariantId);

  return normalized.includes(id)
    ? normalized.filter((item) => item !== id)
    : [...normalized, id];
};
